import { getSingleModel } from '../../utils/helpers'

const auth = getSingleModel('auth')

export const checkIsAdmin = () => auth.authUser?.userInfo?.is_admin === 1
export const getCurrentUser = () => auth.authUser
